import { render, staticRenderFns } from "./right-top-banner.vue?vue&type=template&id=46d7b580&scoped=true&"
import script from "./right-top-banner.vue?vue&type=script&lang=ts&"
export * from "./right-top-banner.vue?vue&type=script&lang=ts&"
import style0 from "./right-top-banner.vue?vue&type=style&index=0&id=46d7b580&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d7b580",
  null
  
)

export default component.exports